import { useCallback } from 'react';

export const useAllieAutocomplete = () => {
  const applySort = useCallback((data: { value: number, text: string }[]) => (
    [...data].sort((a: any, b: any) => {
      const textA = a.text.toUpperCase();
      const textB = b.text.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    })
  ), []);

  const autocompleteChange = useCallback((
    data: any[],
    selector: (data: any) => { value: number, text: string },
    value: string,
  ) => (
    applySort(
      data.map(i => selector(i))
        .filter((item: any) => item.text.toLowerCase().includes(value.toLowerCase()))
    )
  ), []);

  const autocompleteSelect = useCallback((data: any, value: string | number, property = 'id') => (
    data.find(
      (m: any) => m[property] === value
    )
  ), []);

  const autocompleteText = useCallback((
    data: any,
    value: any,
    valueProperty = 'id',
    textProperty = 'name',
  ) => {
    if (!value || !data.length) return '';
    const targetItem = data.find((i: any) => i[valueProperty] === value);
    return targetItem ? targetItem[textProperty] : '';
  }, []);

  return {
    autocompleteChange,
    autocompleteSelect,
    autocompleteText,
    applySort,
  };
};
